/* eslint-disable react/prop-types */
import * as React from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'

import { cn } from '~/lib/utils'

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    className?: string
    start?: string
    end?: string
  }
>(({ className, start, end, ...props }, ref) => {
  const initialValue = Array.isArray(props.value)
    ? props.value
    : [props.min || 0, props.max || 100]
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full touch-none items-center select-none',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className='h-3xs bg-blue-d-40 data-disabled:bg-grey-m dark:bg-blue-d-40 dark:data-disabled:bg-grey-m relative w-full grow overflow-hidden'>
        <SliderPrimitive.Range className='bg-blue-m data-disabled:bg-grey-m dark:bg-blue-l dark:data-disabled:bg-grey-m absolute h-full' />
      </SliderPrimitive.Track>

      <span className='text-base-sm sm:text-base-md lg:text-base-lg absolute -bottom-[40px] left-0'>
        {start !== '' ? start : ''}
        {props.min}
        {end !== '' ? end : ''}
      </span>
      <span className='text-base-sm sm:text-base-md lg:text-base-lg absolute right-0 -bottom-[40px]'>
        {start !== '' ? start : ''}
        {props.max}
        {end !== '' ? end : ''}
      </span>

      {initialValue.map((value, index) => {
        // Calculate the position percentage of the thumb
        const positionPercentage =
          ((value - (props.min || 0)) /
            ((props.max || 100) - (props.min || 0))) *
          100

        // Determine alignment based on position
        const alignment =
          positionPercentage < 5
            ? 'left-0 translate-x-0 text-left'
            : positionPercentage > 95
              ? 'right-0 translate-x-0 text-right'
              : 'left-1/2 -translate-x-1/2 text-center'

        return (
          <SliderPrimitive.Thumb
            key={index}
            className='h-s w-s border-blue-m ring-offset-blue-m hover:bg-blue-l-20 focus-visible:bg-blue-m focus-visible:ring-blue-m data-disabled:border-grey-m dark:border-blue-l dark:focus-visible:bg-blue-l dark:focus-visible:ring-blue-l dark:data-disabled:border-grey-m block rounded-full border-2 bg-white transition-colors focus-visible:border-white focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:outline-hidden hover:data-disabled:bg-white dark:bg-white dark:ring-offset-neutral-950 dark:focus-visible:border-white dark:hover:data-disabled:bg-white'
          >
            <div
              className={cn(
                alignment,
                'bottom-s text-base-sm sm:text-base-md lg:text-base-lg absolute z-30 w-fit transform font-bold text-nowrap'
              )}
            >
              {start !== '' ? start : ''}
              {value}
              {end !== '' ? end : ''}
            </div>
          </SliderPrimitive.Thumb>
        )
      })}
    </SliderPrimitive.Root>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
